import i18n from '@/plugins/i18n'

export default [
    {
        path: '/' + i18n.t('routes.popup.index'),
        name: 'popup.index',
        component: () =>
            import(/* webpackChunkName: "popup" */ '@/views/popups/Index.vue'),
        meta: {
            requiresAuth: true,
            breadcrumb: [
                {
                    text: i18n.t('routes.popup.breadcrumb.index'),
                    to: { name: 'popup.index' },
                    disable: true,
                },
            ],
        },
    },
    {
        path: '/' + i18n.t('routes.popup.create'),
        name: 'popup.create',
        component: () =>
            import(/* webpackChunkName: "popup" */ '@/views/popups/Create.vue'),
        meta: {
            requiresAuth: true,
            breadcrumb: [
                {
                    text: i18n.t('routes.popup.breadcrumb.index'),
                    to: { name: 'popup.index' },
                },
                {
                    text: i18n.t('routes.popup.breadcrumb.create'),
                    to: { name: 'popup.create' },
                },
            ],
        },
    },
    {
        path: '/' + i18n.t('routes.popup.edit') + '/:id',
        name: 'popup.edit',
        component: () =>
            import(/* webpackChunkName: "popup" */ '@/views/popups/Edit.vue'),
        meta: {
            requiresAuth: true,
            breadcrumb: [
                {
                    text: i18n.t('routes.popup.breadcrumb.index'),
                    to: { name: 'popup.index' },
                },
                {
                    text: i18n.t('routes.popup.breadcrumb.edit'),
                    to: { name: 'popup.edit' },
                },
            ],
        },
        props: true,
    },
]
